export default __webpack_public_path__ + "static/media/refund-amico.328d82d7.png";